import type { VerdictType, SentimentType, ConfidenceType } from './types';

export interface ToneSet {
  pill: string;
  text: string;
  border: string;
  bg: string;
  icon: string;
}

const POSITIVE: ToneSet = {
  pill: 'bg-green-100 text-green-700',
  text: 'text-green-700',
  border: 'border-green-200',
  bg: 'bg-green-50',
  icon: 'text-green-500',
};
const NEGATIVE: ToneSet = {
  pill: 'bg-red-100 text-red-700',
  text: 'text-red-700',
  border: 'border-red-200',
  bg: 'bg-red-50',
  icon: 'text-red-500',
};
const NEUTRAL: ToneSet = {
  pill: 'bg-neutral-100 text-neutral-700',
  text: 'text-neutral-600',
  border: 'border-neutral-200',
  bg: 'bg-neutral-50',
  icon: 'text-neutral-400',
};
const MIXED: ToneSet = {
  pill: 'bg-amber-100 text-amber-700',
  text: 'text-amber-700',
  border: 'border-amber-200',
  bg: 'bg-amber-50',
  icon: 'text-amber-500',
};

export function verdictTone(verdict?: VerdictType | string): ToneSet {
  switch (verdict?.toLowerCase()) {
    case 'positive': return POSITIVE;
    case 'negative': return NEGATIVE;
    case 'neutral':  return NEUTRAL;
    case 'mixed':    return MIXED;
    default:         return NEUTRAL;
  }
}

export function sentimentTone(sentiment?: SentimentType | string): ToneSet {
  return verdictTone(sentiment as VerdictType);
}

export function confidenceTone(confidence?: ConfidenceType | string): ToneSet {
  switch (confidence?.toLowerCase()) {
    case 'high':   return POSITIVE;
    case 'medium': return MIXED;
    case 'low':    return NEGATIVE;
    default:       return NEUTRAL;
  }
}

export function statusTone(status?: string): ToneSet {
  switch (status?.toLowerCase()) {
    case 'success': return POSITIVE;
    case 'partial': return MIXED;
    case 'failed':  return NEGATIVE;
    default:        return NEUTRAL;
  }
}

export function formatLabel(s?: string): string {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

export function formatMetricKey(key: string): string {
  return key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatTimestamp(ts: number): string {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(ts));
}
